import "./lib/public-path";
import "requestidlecallback-polyfill";

import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import "lazysizes/plugins/bgset/ls.bgset.js";
import "lazysizes/plugins/bgset/ls.bgset.min.js";
import aos from "aos";
import app from "./lib/app";
import * as tablescapeComponents from "../tablescape";

import * as LoopOnstore from "@loophq/onstore-sdk";
import { TablescapeContext, TablescapeEvent } from "@tablescape/context";

app.add({ ...tablescapeComponents });

window.addEventListener("vue:configured", () => {
  app.mount(["data-component", "data-tbsp-component"]);
});

TablescapeContext.on(
  TablescapeEvent.VARIANT_SELECTED,
  ({ discounts, products, selectedVariant }) => {
    app.emit(TablescapeEvent.VARIANT_PRICE_UPDATED, {
      discounts,
      products,
      selectedVariant,
    });

    app.emit(TablescapeEvent.VARIANT_SELECTED, {
      products,
      selectedVariant,
    });
  }
);

window.lazySizesConfig = window.lazySizesConfig || {};
window.picoApp = app;
window.TablescapeContext = TablescapeContext;
window.LoopOnstore = LoopOnstore;

setTimeout(() => {
  aos.init();
}, 1500);

// add class on body if user is tabbing through the site
window.addEventListener("keydown", function (e) {
  if (e.code === "Tab") {
    document.querySelector("body").classList.add("accessible");
  }
});

window.addEventListener("shopify:section:load", () => {
  app.mount(["data-component", "data-tbsp-component"]);
});

if (typeof window !== "undefined" && "__LOOP_RETURNS_API_KEY__" in window) {
  LoopOnstore.init({
    key: window.__LOOP_RETURNS_API_KEY__,
    full: true,
  });
}
